import { useEffect, useState } from "react";
import { MdWhatsapp } from "react-icons/md";

const Whatsapp = () => {
    const [width, setWidth] = useState({
        winWidth: window.innerWidth
    });

    const detectSize = () => {
        setWidth({
            winWidth: window.innerWidth
        })
    }

    useEffect(() => {
        window.addEventListener('resize', detectSize)

        // window.scrollTo(0, 0);

        return (() => {
            window.removeEventListener('resize', detectSize)
        })
    }, [width])
    return (

        <div style={{ position: "fixed", bottom: "40px", right: "20px", textAlign: "right", color: "green", zIndex: "20" }}>
            {width?.winWidth > 768 ?
                <a
                    href="https://wa.me/8141096997"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        backgroundColor: "#ECE5DD",
                        color: "#4F4F4F",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "14px",
                        padding: "6px 10px",
                        borderRadius: "20px",
                        textDecoration: "none",
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                        width: "fit-content",
                        border: "1px solid #ccc",
                        fontWeight: "bold",
                        height: "40px"
                    }}
                >
                    <MdWhatsapp
                        style={{ width: "20px", height: "20px", marginRight: "8px", color: "green" }}
                    />
                    {/* {width?.winWidth > 768 ? <span style={{ color: "black" }}>WhatsApp us</span> : ""} */}
                    <span style={{ color: "black" }}>WhatsApp us</span>
                </a>
                :
                <a
                    href="https://wa.me/8141096997"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        backgroundColor: "#ECE5DD",
                        color: "#4F4F4F",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "14px",
                        padding: "1px",
                        borderRadius: "20px",
                        textDecoration: "none",
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                        width: "fit-content",
                        border: "1px solid #ccc",
                        fontWeight: "bold",
                        height: "40px"
                    }}
                >
                    <MdWhatsapp
                        style={{ width: "50px", height: "40px", marginRight: "8px", color: "green" }}
                    />
                     {/* <span style={{ color: "black" }}>WhatsApp us</span> */}
                </a>
            }
        </div >
    )
}

export default Whatsapp;